'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { PopoverType } from '../constants/popover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.explicitSave.${suffix}`;
const CancelButton = styled(UIButton).withConfig({
  displayName: "ExplicitSaveControls__CancelButton",
  componentId: "mw6339-0"
})(["color:", " !important;"], OBSIDIAN);
const propTypes = {
  className: PropTypes.string,
  popoverType: PropTypes.oneOf(Object.values(PopoverType)),
  isSubmitDisabled: PropTypes.bool,
  linkType: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  renderLinkPopoverAlert: PropTypes.func
};
function ExplicitSaveControls(props) {
  const {
    className,
    popoverType,
    isSubmitDisabled,
    linkType,
    onSubmit,
    onCancel,
    renderLinkPopoverAlert
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [typeof renderLinkPopoverAlert === 'function' ? renderLinkPopoverAlert(linkType) : null, /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary"
      // @TODO: Rename this to `explicit-save-submit-button` along with
      // all consumer references
      ,
      "data-test-id": "submit-link-confirm-button",
      onClick: onSubmit,
      disabled: isSubmitDisabled,
      size: "small",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`submit.${popoverType}`)
      })
    }), /*#__PURE__*/_jsx(CancelButton, {
      use: "tertiary-light",
      "data-test-id": "explicit-save-cancel-button",
      onClick: onCancel,
      size: "small",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('cancel')
      })
    })]
  });
}
ExplicitSaveControls.propTypes = propTypes;
ExplicitSaveControls.displayName = 'ExplicitSaveControls';
export default ExplicitSaveControls;